<div class="go-back">
  <button class="btn btn-primary me-3" (click)="onRouteClick(routePath)" id="btn-go-back">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>
    Go Back
  </button>
  <div class="h3 text-capitalize mb-0">
    {{ pageTitle }}
  </div>
</div>
